import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { UserHistoryOptions } from '~/shared/data-contract/user-history';
import { userHistoryOptionsSchema } from '~/shared/data-contract/user-history';

export const useUserHistoryOptionsQuery = (userId: string): UseQueryResult<UserHistoryOptions> => {
    const userHistoryOptionsUrl = `/users/${userId}/history/options` as const;
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(userHistoryOptionsSchema, {
                pathname: userHistoryOptionsUrl,
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: [userHistoryOptionsUrl, 'GET'],
    });
};
